import React from 'react';

export interface CardProps {
  children?: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  noPadding?: boolean;
  hoverable?: boolean;
}

export interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export interface CardBodyProps {
  children: React.ReactNode;
  className?: string;
}

export interface CardFooterProps {
  children: React.ReactNode;
  className?: string;
}

const CardHeader: React.FC<CardHeaderProps> = ({ children, className = '' }) => (
  <div className={`px-5 py-4 border-b border-border-0 ${className}`.trim()}>
    {children}
  </div>
);

const CardBody: React.FC<CardBodyProps> = ({ children, className = '' }) => (
  <div className={`px-5 py-4 ${className}`.trim()}>{children}</div>
);

const CardFooter: React.FC<CardFooterProps> = ({ children, className = '' }) => (
  <div className={`px-5 py-4 border-t border-border-0 bg-surface-3 rounded-b-card ${className}`.trim()}>
    {children}
  </div>
);

const Card: React.FC<CardProps> & {
  Header: typeof CardHeader;
  Body: typeof CardBody;
  Footer: typeof CardFooter;
} = ({ children, header, footer, className = '', noPadding = false, hoverable = false }) => {
  return (
    <div
      className={`
        bg-surface-2 border border-border-1 rounded-card shadow-card
        transition-all duration-200
        ${hoverable ? 'hover:border-accent-500/40 hover:shadow-glow-accent' : ''}
        ${className}
      `.trim().replace(/\s+/g, ' ')}
    >
      {header && <CardHeader>{header}</CardHeader>}
      {children && (
        <div className={noPadding ? '' : 'px-5 py-4'}>{children}</div>
      )}
      {footer && <CardFooter>{footer}</CardFooter>}
    </div>
  );
};

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;

export default Card;
